(function(){
    angular
        .module('appback')
        .directive('ngPublicaciones', publicacionesDir);

        publicacionesDir.$inject = ['socket','GenerallabService','FotopublicacionService','$timeout','Upload',"$uibModal"];
        function publicacionesDir(socket,GenerallabService,FotopublicacionService,$timeout,Upload,$uibModal){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=publicaciones.twig',
		          scope: {
		          	categorias : '=',
                  	ngModel : '=',
                  	peticion : '=',
                  	animal : '=',
					//publicacion : '=',
                  //item: '=',
                  //peticionid: '=',
                  //resultados: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
	                    scope.fotoSeleccionada = false;

						scope.revisarLastFlecha = function(){
							if(angular.isDefined(scope.fotoSeleccionada.etiquetas) && angular.isDefined(scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1]) && !scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1].active){
								scope.fotoSeleccionada.etiquetas.splice(scope.fotoSeleccionada.etiquetas.length-1,1);
							}
						}
						console.log("peticion",scope.peticion);
						console.log("animal",scope.animal);
	                    scope.generalLab = GenerallabService;
						scope.cuadradoSeleccionado = false;

						
						if(angular.isUndefined(scope.publicacion)){
							scope.publicacion = {
								lims_id:scope.peticion.lims_id,
								especie_id:scope.animal.especie_id,
                                filepath: [] 
                            };
						}

						if(scope.ngModel){
							FotopublicacionService.getPublicacion(scope.ngModel,function(data){
								scope.publicacion = data.publicacion;
							});
						}

						
						if(angular.isUndefined(scope.info)){
							scope.info = {
                                herramienta: 'selector',
                                tagvalue: ""
                            };
						}

						console.log("scopeinit",scope.publicacion);

		            	scope.options = {
				             zoomEnable          : false,
				             defaultIndex        : 0, // Order of the default selected Image
				             /* You should give images in array with object properties
				              [{
				              thumb : 'assets/images/1-thumb.jpg',
				              medium: 'assets/images/1-medium.jpg',
				              large : 'assets/images/1-large.jpg'
				              }] */
				             images              : [],
				             style               : 'inner', // inner or box
				             boxPos              : 'right-top', // e.g., right-top, right-middle, right-bottom, top-center, top-left, top-right ...
				             boxW                : 400, // Box width
				             boxH                : 400, // Box height
				             method              : 'lens', // fallow 'lens' or 'pointer'
				             cursor              : 'crosshair', // 'none', 'default', 'crosshair', 'pointer', 'move'
				             lens                : true, // Lens toggle
				             zoomLevel           : 2, // 0: not scales, uses the original large image size, use 1 and above to adjust.
				             immersiveMode       : '769', // false or 0 for disable, always, max width(px) for trigger
				             immersiveModeOptions: {}, // can extend immersed mode options
				             immersiveModeMessage: 'Click to Zoom', // Immersive mode message
				             prevThumbButton     : '&#9665;', // Prev thumb button (html)
				             nextThumbButton     : '&#9655;', // Next thumb button (html)
				             thumbsPos           : 'bottom', // Thumbs position: 'top', 'bottom'
				             thumbCol            : 3, // Thumb column count
				             thumbColPadding     : 4 // Padding between thumbs
				         };
		            	scope.options.zoomEnable = false;
		            	console.log("newcard",scope.publicacion);

	                    //scope.publicacion = {};
	                    //scope.categorias = vm.categorias;
	                    scope.selector = { enabled:false };
						scope.visibleHerramienta = false;

						scope.quitarColoresSelect = function(){
							if(angular.isDefined(scope.fotoSeleccionada.drawer)){
								scope.fotoSeleccionada.drawer.forEach(function (cuadrado, index) {
									cuadrado.info.modificando = false;
									cuadrado.color = scope.getColor(cuadrado.info.herramienta);
								});
							}
						}

						scope.changeElemento = function(elemento){
							scope.revisarLastFlecha();
							scope.visibleHerramienta = false;
							switch(elemento){
								case "crop":
									scope.selector.enabled = true;
									break;
								case "selector":
									scope.selector.enabled = true;
									break;
								default:
									scope.visibleHerramienta = true;
									scope.selector.enabled = false;
									scope.mostrarDatos = false;
									break;
							}
							scope.info.herramienta = elemento;
							scope.quitarColoresSelect();
						}
						scope.changeElemento(scope.info.herramienta);
	                   

	                    /*if(typeof(item)!='undefined'){
	                        scope.publicacion = item;
	                    }*/

						scope.borrarSeleccionada = function(index){
							scope.publicacion.filepath.splice(index, 1);
						}

	                    scope.addFotoSeleccionada = function(files){
							console.log("FOTO SELECCIONADA", files);
	                        scope.open = true;
	                        scope.fotoSeleccionada = files;
	                        scope.fotoSeleccionada.url = '/backend/uploads/fotopublicacion/'+files.file_name;
	                    }
	                    scope.close = function(){
							scope.revisarLastFlecha();
							scope.selector.clear();
							scope.mostrarDatos = false;
	                        scope.open = false;
	                    }
	                    scope.buscarEspecie = function(){
	                      console.log("blur");
	                      FotopublicacionService.buscarEspecie(scope.publicacion.lims_id,function(data){
	                         if(data.animal){
	                            scope.publicacion.especie_id = data.animal.especie_id;
	                         }
	                      });
	                    }

	                    scope.drawer = [
	                        
	                    ];

						scope.reiniciarCampos  = function(){
							scope.info = { herramienta:scope.info.herramienta};
						}

						scope.removeDrawer = function(index){
							scope.fotoSeleccionada.drawer.splice(index, 1);
						}


						scope.removeEtiqueta = function(index){
							scope.fotoSeleccionada.etiquetas.splice(index, 1);
						}
						scope.getColor = function(type){
							var color = "#d8e2dc";
							if(type=="crop"){
								color = "#d8e2dc";
								// color = "#e5e5e5";
								// color = "#0077b6";
								// color = "#023e8a";
							}
							if(type=="selector"){
								// color = "#eeef20";
								color = "#fbe134";
							}
							return color;
						}

						scope.color = "#a94442"
						
	                    scope.addRect = function (selector) {
							
							//dirScope.mostrarDatos = false;
							//console.log("scope",scope);
							console.log("ADD RECT");
							switch(scope.info.herramienta){
								case "crop":
								case "selector":
									console.log("fotoSeleccionada",scope.fotoSeleccionada);
									if(angular.isUndefined(scope.fotoSeleccionada.drawer)){
										scope.fotoSeleccionada.drawer = [];
									}
									if(scope.info.herramienta=="crop"){
										scope.color = scope.getColor("crop")
									}
									if(scope.info.herramienta=="selector"){
										scope.color = scope.getColor("selector")
									}
									if(scope.info.modificando){
										scope.fotoSeleccionada.drawer[scope.cuadradoSeleccionadoKey].info = scope.info;
										scope.fotoSeleccionada.drawer[scope.cuadradoSeleccionadoKey].title = scope.info.tagvalue;
										scope.fotoSeleccionada.drawer[scope.cuadradoSeleccionadoKey].label = scope.info.tagvalue;
									}else{
										scope.fotoSeleccionada.drawer.push({
											x1: scope.selector.x1,
											y1: scope.selector.y1,
											x2: scope.selector.x2,
											y2: scope.selector.y2,
											color: scope.color,
											stroke: 3,
											title: scope.info.tagvalue,
											label: scope.info.tagvalue,
											info:scope.info
											//pie_foto:scope.publicacion.pie_foto,
											//mostrar_informe:scope.publicacion.mostrar_informe
										});
									}
									
									scope.reiniciarCampos();
									console.log("fotoSeleccionadanew",scope.fotoSeleccionada);
									//scope.fotoSeleccionada.drawer = scope.drawer; 
									selector.clear();
								break;
								case "arrow":
									//console.log("event.ctrlKey",event.ctrlKey);
									
									scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1].info = scope.info;
									scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1].active = true;
								
									break;
							}
							scope.quitarColoresSelect();
	                       
	                    };

						console.log("MOUSEMOVE");
						
						scope.insertarEndibujo = function(event){
							//console.log("Event",event);
							//console.log("insertarEndibujo",event.ctrlKey);

							if(!scope.visibleHerramienta){
								return false;
							}
							if(angular.isUndefined(scope.fotoSeleccionada.etiquetas)){
								scope.fotoSeleccionada.etiquetas = [];
							}
							console.log("ddd",scope.fotoSeleccionada.etiquetas);
							if(scope.fotoSeleccionada.etiquetas.length==0){
								var contadorFlecha = 1;
							}else{
								if(!isNaN(scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1].label)){
									var contadorFlecha = scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1].label+1;
								}else{
									var contadorFlecha = 1;
								}
							}
							scope.fotoSeleccionada.etiquetas.push({
	                            x: scope.x,
	                            y: scope.y,
	                            color: '#a94442',
	                            //stroke: 3,
								//herramienta: scope.publicacion.herramienta,
	                            title:contadorFlecha,
								active:false,
	                            label:contadorFlecha,
								info:scope.info
	                        });
	                        scope.reiniciarCampos();

							console.log("cope.fotoSeleccionada",scope.fotoSeleccionada);
						}
						scope.x = 0;
						scope.y = 0;
						$(document).on('mousemove', '.fotoRevisionIa', function(event) {
							const offset = $(this).offset(); // Obtener la posición del elemento
							scope.x = event.pageX - offset.left; // Coordenada X relativa a la foto
							scope.y = event.pageY - offset.top;  // Coordenada Y relativa a la foto
							$('.herramientaDraw').css({
								top:scope.y+"px",
								left:scope.x+"px"
							})
							//console.log(`Coordenadas del ratón sobre la foto: X=${scope.x}, Y=${scope.y}`);
						});


						scope.cartaModal = false
						scope.mostrarDatos = false;
						scope.addPublicacion = function(peticion,categoria,item){
							scope.cartaModal = $uibModal.open({
								animation: true,
								ariaLabelledBy: 'modal-title-top',
								ariaDescribedBy: 'modal-body-top',
								templateUrl: 'addpublicacion.html',
								size: 'md',
								backdrop:'static',
								controller: function($scope) {
									$scope.dirScope = scope;
									$scope.iaCheck = function(rect,index){
										FotopublicacionService.iaCheck(rect,scope.fotoSeleccionada,function(data){
											rect.info.lastia = data.result.resultado;
											$scope.editRect(rect,index);
											console.log("rect",rect)
										});
									} 
									$scope.iaCheckPreview = function(){
										rect = {x1:$scope.dirScope.selector.x1, y1:$scope.dirScope.selector.y1, x2:$scope.dirScope.selector.x2, y2:$scope.dirScope.selector.y2};
										console.log("rect generado",rect);
										FotopublicacionService.iaCheck(rect, scope.fotoSeleccionada, function(data){
											console.log("respuesta chatgpt preview", data.result.resultado);
											$scope.dirScope.info.lastia = data.result.resultado;
										});
									}
									$scope.iaCheckGen = function(){
										FotopublicacionService.iaCheckGeneral(scope.fotoSeleccionada,function(data){
											scope.fotoSeleccionada.descripcion = data.result.resultado;
										});
									}
									$scope.contarCuadros = function(herramienta,fotoSel){
										var contador = 0;
										if(angular.isDefined(fotoSel.drawer)){
											for(var i=0;i<fotoSel.drawer.length;i++){
												if(fotoSel.drawer[i].info.herramienta==herramienta){
													contador++;
												}
											}
										}
                                        return contador;

									}
									$scope.enviarInfo = function(){
										scope.info.pie_foto = scope.info.pie_foto += "<p>"+scope.info.lastia+"</p>";
									}
									$scope.editRect = function(rect,index){
										console.log("rect",rect);
										scope.quitarColoresSelect();
										if(rect){
											scope.changeElemento(scope.info.herramienta);
											rect.info.modificando = true;
											rect.color = '#a94442';
											console.log("rect",rect);
											scope.cuadradoSeleccionado = rect;
											scope.cuadradoSeleccionadoKey = index;
											scope.info = angular.copy(rect.info);
											scope.info.modificando = true;
											
											//scope.info.herramienta
											$scope.allowIAPreview = false;
											scope.mostrarDatos = true;
										}
									}
									$scope.changeDatos = function(){
										scope.mostrarDatos = !scope.mostrarDatos;
									}
									$scope.getNextFlecha = function(){
										var contadorFlecha = 1;
										
										if(angular.isDefined(scope.fotoSeleccionada.etiquetas) && angular.isDefined(scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1].label) && !isNaN(scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1].label)){
											var contadorFlecha = scope.fotoSeleccionada.etiquetas[scope.fotoSeleccionada.etiquetas.length-1].label+1;
										}else{
											var contadorFlecha = 1;
										}
										return contadorFlecha;
									}
									console.log("peticion",peticion);
									console.log("itemitem",item);
									$scope.publicacion = scope.publicacion;
									scope.mostrarDatos = false;
									$scope.allowIAPreview = false;
									$scope.onMouseDown = function(event){
										scope.info.modificando = false;
										scope.mostrarDatos = false;
										scope.quitarColoresSelect();
									}	

									/*$scope.trackMouse = function (event) {
										// Capturar las coordenadas X e Y relativas al div
										$scope.mouseX = event.offsetX; // Coordenada X del ratón dentro del div
										$scope.mouseY = event.offsetY; // Coordenada Y del ratón dentro del div
									
										let colisiones = []; // Lista para guardar los cuadrados en colisión
									
										// Verificar colisiones con los cuadrados
										scope.fotoSeleccionada.drawer.forEach(function (cuadrado, index) {
											if (
												$scope.mouseX >= cuadrado.x1 &&
												$scope.mouseX <= cuadrado.x2 &&
												$scope.mouseY >= cuadrado.y1 &&
												$scope.mouseY <= cuadrado.y2 &&
												event.ctrlKey // Solo si la tecla Ctrl está presionada
											) {
												colisiones.push({ cuadrado, index }); // Guardar cuadrado y su índice
											}
											// Restaurar el color original si no hay colisión
											//console.log("cuadrado",cuadrado.info.modificando);
											if(!cuadrado.info.modificando){
												cuadrado.color = scope.getColor(cuadrado.info.herramienta);
											}
										});
									
										if (colisiones.length > 0) {
											// Determinar el cuadrado más centrado respecto al mouse
											let centrado = colisiones.reduce((centrado, actual) => {
												const distanciaCentradaActual = Math.abs(
													($scope.mouseX - (actual.cuadrado.x1 + actual.cuadrado.x2) / 2) +
													($scope.mouseY - (actual.cuadrado.y1 + actual.cuadrado.y2) / 2)
												);
												const distanciaCentradaAnterior = Math.abs(
													($scope.mouseX - (centrado.cuadrado.x1 + centrado.cuadrado.x2) / 2) +
													($scope.mouseY - (centrado.cuadrado.y1 + centrado.cuadrado.y2) / 2)
												);
												return distanciaCentradaActual < distanciaCentradaAnterior ? actual : centrado;
											});
											
											// Cambiar el color del cuadrado más centrado
											centrado.cuadrado.color = "#9d0208";
											
											// Guardar el cuadrado y su índice en $scope
											scope.cuadradoSeleccionado = centrado.cuadrado;
											scope.cuadradoSeleccionadoKey = centrado.index;
										}
									};*/
									

									$scope.onMouseUp = function(){
										
										scope.info = { herramienta: scope.info.herramienta };
										scope.revisarLastFlecha();
										$timeout(function(){
											if(scope.info.herramienta=='crop'){
												scope.info.mostrar_informe = true;
											}else{
												scope.info.mostrar_informe = false;
											}
											if(angular.isUndefined(scope.selector.y1) && scope.info.herramienta!='arrow'){
												scope.mostrarDatos = false;
											}else{
												console.log("ON MOUSE UP");
												scope.mostrarDatos = true;
												$scope.allowIAPreview = true;
											}
										},50)
										
									}
									$scope.item = item;
									console.log("$scope.publicacion",$scope.publicacion);
									$scope.okForm = function(){
										console.log("newcard",$scope.publicacion);
										FotopublicacionService.nuevaPublicacion($scope.publicacion,function(data){
											$scope.publicacion = data.publicacion;
											scope.publicacion = data.publicacion;
											
											scope.ngModel = data.publicacion.id;
											scope.cartaModal.close();
										});
									}

									$scope.uploadFiles = function (files) { 
										//console.log("item",item);
										if (files && files.length) {
										  for (var i = 0; i < files.length; i++) {
											Upload.upload({
												  url: '/backend/fotopublicacion/subirficheros',
												  data: { file: files[i] }
											  }).then(function (resp) {
												  //console.log(resp);
												  if(typeof(scope.publicacion.filepath) == 'undefined'){
													  scope.publicacion.filepath = [];
												  }
												  resp.data.drawer = [];
												  scope.publicacion.filepath.push(resp.data);
			
											  }, function (resp) {
												  //console.log('Error status: ' + resp.status);
											  }, function (evt) {
												  var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
												  //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
											  });
										  }
										  //files = null;
			
										}
									}
									$scope.koFormInfo = function(){
										scope.mostrarDatos = false;
										scope.revisarLastFlecha();
									}
									$scope.koForm = function(){
										console.log("koform");
										scope.cartaModal.close();
									}

									$scope.onPaste = function(event) {
										console.log("Evento paste detectado:", event);
									
										const clipboardData = event.originalEvent.clipboardData || window.clipboardData;
									
										if (!clipboardData) {
											console.warn("No se pudo acceder al portapapeles");
											return;
										}
									
										console.log("Datos del portapapeles:", clipboardData);
									
										const items = clipboardData.items;
									
										for (let i = 0; i < items.length; i++) {
											const item = items[i];
											console.log(`Item ${i}:`, item);
									
											// Verifica si el contenido es una imagen
											if (item.type.indexOf('image') !== -1) {
												const file = item.getAsFile();
									
												if (file) {
													console.log("Imagen detectada:", file);
													// Llama a la función para manejar la imagen
													$scope.uploadFiles([file]);
												} else {
													console.warn("No se pudo obtener el archivo de la imagen");
												}
											}
										}
									}

									$(document).on('paste', $scope.onPaste);
									$scope.$on('$destroy', function() {
										$(document).off('paste', $scope.onPaste);
									});

								
								}
							});
						}
			        });
					
					

					

					
		        }
          }
      }
})();